module.exports = __webpack_public_path__ + "static/img/404-cloud.0f4bc32b.png";